export const HANDLE_GET_GROUP_LIST="HANDLE_GET_GROUP_LIST";